import { handleActions } from 'redux-actions'
import * as aiActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [aiActions.getAiCounterInfoRequest](state, action) {
      return true
    },
    [aiActions.getAiCounterInfoSuccess](state, action) {
      return false
    },
    [aiActions.resetState](state, payload) {
      return defaultState
    },
  },
  defaultState
)
